<script setup lang="ts">
import profile from '@/assets/images/profile.webp';
import { toShortAddress } from '@/utils/helpers';
import { computed } from '#imports';

const props = defineProps<{
    address: string;
}>();

const shortAddress = computed(() => toShortAddress(props.address));

</script>

<template>
  <div v-bind="$attrs"
       class="display-flex align-items-center gap-40 flex-wrap"
  >
    <ImgMain :src="profile"
             alt="Avatar"
             quality="90"
             densities="x1 x2"
             class="avatar"
    />

    <p class="display-800-accent">
      {{ shortAddress }}
    </p>
  </div>
</template>

<style scoped lang="scss">
:deep(.avatar) {
  width: 100%;
  max-width: 120px;
  max-height: 120px;
  border-radius: 100%;
}
</style>
